/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-12-22 11:40:48
 * @FilePath: \sns-user-frontend\src\stores\user.js
 * @Description: 用户层数据
 */

import http from '@/service'
import jsBridge from '@/jsBridgeApi'
import { defineStore, storeToRefs } from 'pinia'
import { useMsgStore } from '@/stores/message'
import { useSystemStore } from '@/stores/system'
import { getQueryVariable } from '@/utils'
/// <reference types="@heytap/account_web_sdk_dts" />

const environment = location.origin.includes('wanyol') || location.origin.includes('172.') || location.origin.includes('localhost') ? 'test' : 'prod'

let interval = null

// 获取账号登录参数
function getLoginParams (redirectUrl) {
  const systemStore = useSystemStore()
  const { brandName, isPRD } = storeToRefs(systemStore)
  let sdkBrandName = brandName.value
  if (sdkBrandName === 'oneplus' && import.meta.env.VITE_COUNTRY === 'PARIS') {
    sdkBrandName = 'oneplus_oversea'
  }
  const bizAppKey = import.meta.env[`VITE_BIZKEY${isPRD.value ? '_PRD' : ''}`]
  const callbackUrl = redirectUrl || (import.meta.env.VITE_ENV === 'DEV' ? `${import.meta.env.VITE_TEST_DOMAIN}` : location.href)

  return {
    bizAppKey,
    callbackUrl,
    brandName: sdkBrandName
  }
}

// app登录
function appLogin () {
  try {
    jsBridge.loginPage()
  } catch (e) {
    console.log('app login fail', e)
  }
}

export const useUserStore = defineStore('userStore', {
  state: () => ({
    isBetaUser: false,
    userInfo: {},
    loginPoperVisible: false,
  }),
  getters: {
    uid (state) {
      return state.userInfo.uid
    },
    getPermission (state) {
      if (!Object.keys(state.userInfo).length) return {}
      const permission = state.userInfo.permap || {}
      Object.keys(permission).forEach(p => {
        permission[p] = Boolean(Number(permission[p]))
      })
      return permission
    },
  },
  actions: {
    // 获取用户详情
    async requestUserInfo (uid = '') {
      // 系统消息未读红点键名转换
      const replaceKey = (data) => {
        const {
          systemNum: notificationDot,
          normalNum: activitiesDot,
          followerNum: followersDot,
          likesNum: likesDot,
          privateChatNum: messagesDot,
          pollingTime: loopTime
        } = data
        return { 
          notificationDot,
          activitiesDot,
          followersDot,
          likesDot,
          messagesDot,
          loopTime
        }
      }
      let params = {};
      let sourceField = getQueryVariable("source");
      if (sourceField) {
        params.source = sourceField;
      }
      if (uid) {
        params.uid = uid
      }
      
      try {
        const { data, msg, code } = await http.getUserInfo(params)
        if (uid) {
          return {
            code,
            data,
            msg
          }
        }
        let loginImplicitAuthNStatus = localStorage.getItem('loginImplicitAuthNStatus')
        if (code === 401 || code === 415 || code === 402) {
          sessionStorage.removeItem('isLogin')
          if (loginImplicitAuthNStatus === 'success') {
            console.log('sync login status failed!!!!!!')
            localStorage.removeItem('loginImplicitAuthNStatus')
          } else {
            if (!getQueryVariable('code')) {
              this.onCheckLogin()
            }
          }
          return
        }
        localStorage.removeItem('loginImplicitAuthNStatus')
        if (code === 200 && data && Object.keys(data).length) {
          sessionStorage.setItem('isLogin', true)
          this.userInfo = { ...data }
          const msgStore = useMsgStore()
          const { loopTime } = storeToRefs(msgStore)
          // 发起积分国家查询
          if (import.meta.env.VITE_COUNTRY !== 'GLOBAL') {
            http.openPointsSearch()
          }
          http.getMessageNum().then(res => {
            if (res.code === 200 && res.data) {
              msgStore.msgNum = replaceKey(res.data)
            }
          })
          if (!interval) {
            interval = setInterval(async () => {
              const { code, data, msg } = await http.getMessageNum()
              if (code === 200 && data) {
                msgStore.msgNum = replaceKey(data)
              }
              if (code === 401) {
                clearInterval(interval)
                interval = null
                this.userInfo = {}
                msgStore.msgNum = {}
              }
            }, loopTime.value * 1000)
          }
         
        } else {
          sessionStorage.removeItem('isLogin')
          clearInterval(interval)
          interval = null
        }
      } catch (e) {
        throw new Error(e)
      }
    },
    // 检查是否存在其他业务登录
    async onCheckLogin () {
      const AccountClient = window.account_web_sdk
      const {
        brandName,
        bizAppKey,
        callbackUrl,
      } = getLoginParams()
      const Account = new AccountClient({ 
        brand: AccountClient.supportBrand[brandName],
        environment,
        enableLog: true,
      })
      Account
      .loginImplicitAuthN({
        bizAppKey,
        callbackUrl,
      })
      .then((res) => {
        if (res && typeof res.code === "string") {
          let locationsSearch = location.search.split('?').join('').split('&').filter(i => !i.includes('code') && !!i)
          let params = locationsSearch.reduce((a, b, index) => {
            if (index === (locationsSearch.length - 1)) {
              b = `${b}&code=${code}`
            }
            return `${a}${a ? '&' : '?'}${b}`
          }, '') || `?code=${res.code}`
          localStorage.setItem('loginImplicitAuthNStatus', 'success')
          location.replace(`${location.origin}${params}`)
        } else {
          localStorage.setItem('loginImplicitAuthNStatus', 'fail')
        }
      })
      .catch((res) => {
        console.error("Oops! Sync failed.", res.errMessage);
      });
    },
    // 登录 loginType: h5(账号sdk登录) app(app登录)
    async onLogin (params) {
      const {
        loginType,
        redirectUrl = ''
      } = params || {}
      const systemStore = useSystemStore()
      const { isApp, isOneplus, versionCode } = storeToRefs(systemStore)    
      // app登录， 1+app登录新版才支持
      if (
        (isApp.value && (!loginType || loginType === 'app') && (!isOneplus.value || (isOneplus.value && versionCode.value >= 41700)))
      ) {
        appLogin()
        return
      }
      const {
        brandName,
        bizAppKey,
        callbackUrl,
      } = getLoginParams(redirectUrl)

      const AccountClient = window.account_web_sdk
      const Account = new AccountClient({ 
        brand: AccountClient.supportBrand[brandName],
        environment,
        enableLog: true,
      })

      Account.loginPage({
        bizAppKey,
        callbackUrl,
        language: import.meta.env.VITE_COUNTRY === 'CHINA' ? 'zh-CN' : 'en_US'
      })
    },
    // 登出
    async onLogout () {
      const {
        brandName,
        bizAppKey,
        callbackUrl,
      } = getLoginParams(location.href)
      const AccountClient = window.account_web_sdk
      const Account = new AccountClient({ 
        brand: AccountClient.supportBrand[brandName],
        environment,
        enableLog: true,
      })
      let redirectUrl = ''
      try {
        const hasSearch = !!new URL(callbackUrl).search
        redirectUrl = `${location.href}${hasSearch ? '&' : '?'}logOut=true`
      } catch (error) {
        redirectUrl = `${callbackUrl}?logOut=true`
      }

      Account.logout({
        bizAppKey,
        callbackUrl: redirectUrl,
        language: import.meta.env.VITE_COUNTRY === 'CHINA' ? 'zh-CN' : 'en_US'
      })
    },
    // 登录确认弹窗显示
    onShowLoginPopup () {
      const systemStore = useSystemStore()
      const { isApp, isWap } = storeToRefs(systemStore)
      // wap弹窗确认是否登录
      if (isWap.value && !isApp.value) {
        this.loginPoperVisible = true
      }
    },
    onCloseLoginPopup () {
      this.loginPoperVisible = false
    }
  }
})
